import { FC } from "react";
import { useParams } from 'react-router-dom';
import { useQueryClient } from "react-query";
import { useGetProduct } from '../../../services/product/product.service';
import { useFetchErrorToast } from '../../../utils/useFetchErrorToasts/useFetchErrorToast';
import useNavigateWithToast from '../../../utils/useNavigateWithToast/useNavigateWithToast';
import Header from "../../Bases/Header";
import EditProductForm from "./EditProductForm";
import Loading from "../../../components/Loading/Loading";

const EditProduct: FC = () => {
  const navigateWithToast = useNavigateWithToast();
  const queryClient = useQueryClient();
  const {
    classId: classIdParam,
    productId: productIdParam
  } = useParams<{ classId: string, productId: string }>();
  const classId = +(classIdParam ?? '-1');
  const productId = +(productIdParam ?? '-1');

  const {
    data: getProductResponse,
    isError: getProductIsError,
    error: getProductError
  } = useGetProduct({ classId, productId });
  const product = getProductResponse?.data;

  useFetchErrorToast([
    {
      label: 'Error fetching product data',
      id: 'productDataFetchError',
      isError: getProductIsError,
      error: getProductError
    }
  ]);

  const navigateToTableWithSuccessToast = () => {
    queryClient.invalidateQueries(['getProduct', classId, productId]);
    navigateWithToast(
        '/tables/products',
        {
          label: 'Product has been updated successfully',
          id: 'productUpdateSuccess'
        }
    );
  };

  return (
      <>
        <Header
            breadcrumb={{ label: 'Back to Product Table', to: '/tables/products' }}
            title={`View Product ${product?.productNo ?? ''} - ${product?.longDescription ?? ''}`}
        />
        {!!product
            ? <EditProductForm
                product={product}
                onSuccess={navigateToTableWithSuccessToast}
            />
            : <Loading size={12}/>
        }
      </>
  );
};

export default EditProduct;